import React from 'react'

import { Suspense } from '~/components/elements/Suspense'
import { checkCurrentSurvey } from '~/hoc/checkCurrentSurvey'
import { useSurveyQuery } from '~/hooks/useSurveyQuery'

import { CustomerAttributeList } from './components/CustomerAttributeList'

export const CustomerAttributeListPage = checkCurrentSurvey(() => {
  const { isLoading } = useSurveyQuery()

  return (
    <Suspense loading={isLoading}>
      <CustomerAttributeList />
    </Suspense>
  )
})
